import { KeyboardArrowDown, MoreHoriz, Search } from "@material-ui/icons";
import React from "react";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PhoneNumber from "../Common/phoneNumber";
import DeletePrompt from "../Common/DeletePrompt";
import { toastMessage } from "../Common/Common";
import {
  getUserRolesAction,
  homeBuyersUserAction,
  removeUsersAction,
  forgotPasswordAction,
  reActivateDeletedUserAction,
  searchUserAction,
} from "./../../actions/UserActions";
import noRecord from "./../../assets/img/no-record.png";
import * as code from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import _ from "lodash";

class Buyers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showArchieve: false,
      show: false,
      showDelete: "Clients",
      showLoader: true,
      searchParam: "",
      modalUserData: {},
      modalCmpnyData: {},
      buyers: [],
      searchedVendors: [],
      originalbuyers: [],
      filteredbuyers: [],
      deletePrompt: false,
      userId: "",
      recordPerPage: code.RECORD_PER_PAGE,
      page: 0,
    };
    this.removeBuyerById = this.removeBuyerById.bind(this);
  }

  columns = [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Appointments",
      selector: "transactions",
      sortable: true,
      width: "120px",
      center: true,
      ignoreRowClick: true,
    },
    {
      name: "Phone Number",
      selector: "mobile",
      sortable: true,
    },
    {
      name: "Email",
      selector: "email",
      sortable: true,
      width: "25%",
    },
    {
      name: "",
      selector: "active",
      sortable: true,
      width: "115px",
      ignoreRowClick: true,
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "50px",
    },
  ];

  getHomeBuyersList(pageIndex) {
    this.props
      .homeBuyersUserAction(this.state.recordPerPage, pageIndex)
      .then((res) => {
        this.setState({
          buyers: this.props.buyers || [],
          originalbuyers: this.props.buyers || [],
          filteredbuyers: this.props.buyers || [],
        });
      })
      .catch((err) => {});
  }
  changePage = async (page) => {
    if (this.state.isSearched) {
      this.searchBuyers(this.state.searchParam, page - 1);
    } else {
      this.getHomeBuyersList(page - 1);
    }
  };
  componentWillMount() {
    this.getHomeBuyersList(this.state.page);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
    this.setState({ showLoader: false });
  }

  removeBuyerById(uId) {
    this.setState({ showLoader: true, deletePrompt: false });
    this.props.removeUsersAction(uId).then((res) => {
      if (this.props.status) {
        this.setState({ showLoader: false });
        this.getHomeBuyersList(this.state.page);
      }
    });
  }

  openDeletePrompt(id) {
    this.setState({
      deletePrompt: true,
      userId: id,
    });
  }
  /**
   * @desc search data within data table
   * @param {*} param
   */
  searchBuyers(param, page = this.state.page) {
    this.props
      .searchUserAction("Buyer", param.trim(), this.state.recordPerPage, page)
      .then((response) => {
        this.setState({
          buyers: response.data.data,
          searchedTransactions: response.data.data,
          showLoader: false,
        });
      })
      .catch((err) => {});
  }
  getSearchResult = _.debounce((param) => {
    this.setState({ showLoader: true });
    this.searchBuyers(param);
  }, 1000);
  search(param) {
    this.getSearchResult(param);
    this.setState({
      searchParam: param,
      isSearched: param.trim() == "" ? false : true,
    });
  }

  goToTransaction(t) {
    localStorage.setItem("transactions", JSON.stringify(t));
    this.props.history.push({
      pathname: "/artwork",
      transactions: t,
    });
  }

  requestResetPassword(email) {
    let data = { email: email.toLowerCase() };
    this.props.forgotPasswordAction(data).then((res) => {
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, message.PASSWORD_RESET_LINK_SENT);
        this.setState({
          forgotSuccess: true,
        });
      }
    });
  }

  reActivateUser(userId) {
    this.props
      .reActivateDeletedUserAction(userId)
      .then((response) => {
        this.getHomeBuyersList(this.state.page);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    let rows = [];

    for (var i = 0, len = this.state.buyers.length; i < len; i++) {
      let user = this.state.buyers[i];

      let data = {
        id: user._id,
        name: (
          <Link to={"/UserProfile/" + user._id} className="p-0 text-capitalize">
            {user.firstname} {user.lastname}
          </Link>
        ),
        mobile: <PhoneNumber phoneNumber={user.mobileNumber} />,
        email: <div className="email-case">{user.email.address}</div>,
        transactions: user.transactions ? (
          user.transactions.length > 0 ? (
            <Button
              variant="link"
              className="p-0"
              onClick={() => this.goToTransaction(user.transactions)}
            >
              {" "}
              {user.transactions.length}
            </Button>
          ) : (
            "0"
          )
        ) : (
          "0"
        ),
        active: (
          <Button
            variant="primary"
            className={"btn-blue btn-grid "}
            disabled={!user.isDeleted}
            onClick={() => this.reActivateUser(user._id)}
          >
            Activate
          </Button>
        ),
        action: !user.isDeleted ? (
          <Dropdown alignRight className="dropdown-action">
            <Dropdown.Toggle
              variant="transparent"
              id="dropdown-folder1"
              className="p-0"
            >
              <MoreHoriz />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                className="color-dark-orange-3 font-14"
                onClick={() => {
                  this.openDeletePrompt(user._id);
                }}
              >
                Remove
              </Dropdown.Item>
              <Dropdown.Item
                className="color-dark-orange-3 font-14"
                onClick={() => {
                  this.requestResetPassword(user.email.address);
                }}
              >
                Reset Password
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ) : null,
      };

      rows.push(data);
    }

    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col className="col-auto">
            <h4 className="title-med mt-0 pt-1">{this.state.showDelete}</h4>
          </Col>
          <Col className="col-auto">
            <Form.Group controlId="" className="mb-0 mr-2" />
          </Col>
          <Col align="right">
            <div className="icon-wrapper ml-2" style={{ width: "40%" }}>
              <Form.Control
                type="text"
                className="form-control-head"
                placeholder="Search"
                value={this.state.searchParam}
                onChange={(e) => {
                  this.search(e.target.value);
                }}
              />
              <span className="form-control-icn">
                <Search />
              </span>
            </div>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Clients Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              pagination={true}
              paginationServer={true}
              paginationTotalRows={this.props.totalbuyers}
              paginationPerPage={this.state.recordPerPage}
              onChangePage={(page) => this.changePage(page)}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
            />

            {this.state.showLoader === true && (
              <div className="page-loader">
                <div className="page-loader-inner">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            )}

            <DeletePrompt
              deletePrompt={this.state.deletePrompt}
              itemId={this.state.userId}
              cancel={() => {
                this.setState({ deletePrompt: false });
              }}
              deleteConfirm={this.removeBuyerById}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    buyers: state.reducer.buyers,
    totalbuyers: state.reducer.totalbuyers,
    roles: state.reducer.roles,
    status: state.reducer.status,
  };
};

export default connect(
  mapStateToProps,
  {
    homeBuyersUserAction,
    getUserRolesAction,
    removeUsersAction,
    forgotPasswordAction,
    reActivateDeletedUserAction,
    searchUserAction,
  }
)(Buyers);
